
import React, { Fragment } from 'react'

const ApplicationFooter = () =>
{
	return (
		<Fragment>
			<div className="app-footer">
				<div className="app-footer__inner">
					<div className="app-footer-left">
					
					</div>
					<div className="app-footer-right">
						<div className="text-center opacity-8">
							<small>Copyright &copy; CDLSI 2025</small>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default ApplicationFooter
